import { Box } from '@mui/material';

import { useFormContext } from 'react-hook-form';
import { makeStyles } from '@mui/styles';
import { NaicsCodeAutoComplete } from '../../naics/NaicsCodeAutoComplete';

/**
 * Renders the primary and secondary Industry Code components
 * @param {String} name - type of Industry Code (naicsCode or secondNaicsCode)
 */

export const NaicsCodeField = ({ name, ...props }: any) => {
  const { setValue } = useFormContext();
  const classes = useNaicsCodeStyles();
  const autoCompleteClasses = useAutcompleteStyles();

  const handleInputChange = (nextInputValue: any) => {
    // input value must only be number
    if (typeof nextInputValue === 'string') {
      return setValue(name, Number(nextInputValue.split(' ')[0]));
    }
    setValue(name, nextInputValue);
  };

  return (
    <Box className={classes.root}>
      <NaicsCodeAutoComplete
        name={name}
        onInputChange={handleInputChange}
        {...props}
        classes={autoCompleteClasses}
      />
    </Box>
  );
};

const useNaicsCodeStyles = makeStyles(() => ({
  root: {
    width: '80%',
  },
  inline: {
    '& input': {
      padding: '6px !important',
    },
  },
}));

const useAutcompleteStyles = makeStyles(() => ({
  input: {
    border: 0,
  },
}));
